'use client';

import { TrackedErrorPage } from '@/components/Page/TrackedErrorPage';

type PageError = {
  error: Error & { status?: number; statusCode?: number };
};

export default function Error({ error }: PageError) {
  const statusCode = error.status ?? error.statusCode ?? 500;
  return <TrackedErrorPage statusCode={statusCode} />;
}
